
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchData } from "../api/mainapi";
import RouteHelper from "../utils/RouteHelper";

const AuthContext = createContext();

export const getCurrentSessionKey = function() {
  return localStorage.getItem("sessionKey")
}

const saveSessionKey = function(sessionKey) {
  localStorage.setItem("sessionKey", sessionKey);
}

export const AuthProvider = ({ children }) => {
    const [ sessionViewData, setSessionViewData ] = useState({ loading: true, data: null });
    const [ sessionKey, setSessionKey ] = useState(getCurrentSessionKey());

    const getData = async(sessionKey) => {
      var result;
      if (sessionKey) {
        try {
          result = await fetchData(`account`);
        } catch(error) {
          result = null;
        }
      } else {
          result = null;
      }
      setSessionViewData(viewData => Object.assign({}, viewData, {
        loading: false,
        data: result
      }));
    }
  
    useEffect(() => {
      setSessionViewData(viewData => Object.assign({}, viewData, { loading: true }));
      getData(sessionKey);
    }, [ sessionKey ]);

    useEffect(() => {
      setSessionKey(getCurrentSessionKey());
    }, [ ]);

    const logout = useCallback(() => {
      localStorage.setItem("sessionKey", null);
      setSessionViewData(sessionViewData => Object.assign({}, sessionViewData, {
        loading: false,
        data: null
      }));
    }, []);

    const login = useCallback(async(sessionKey) => {
      setSessionKey(sessionKey)
      saveSessionKey(sessionKey);
    }, []);

    const refreshData = useCallback(async() => {
      await getData(sessionKey);
    }, [ sessionKey ]);

    const saveRedirect = useCallback(function(redirect) {
      const redirectObject = typeof redirect === "string" && redirect ? RouteHelper.decodeRedirectData(redirect) : null;
      if (redirectObject) {
          localStorage.setItem("redirect", redirect);
      }
    }, []);

    const getCurrentRedirect = useCallback(function() {
      const redirect = localStorage.getItem("redirect");
      const redirectObject = redirect ? RouteHelper.decodeRedirectData(redirect) : null;
      localStorage.removeItem("redirect");
      return RouteHelper.buildUrlFromRedirectData(redirectObject, '/account');
    }, []);

    const hasPendingRedirect = useCallback(function() {
      return !!localStorage.getItem("redirect");
    }, []);

    return (
        <AuthContext.Provider value={{ sessionViewData, logout, login, refreshData, saveRedirect, getCurrentRedirect, hasPendingRedirect }}>
          {children}
        </AuthContext.Provider>
      );
}

export const useAuth = () => useContext(AuthContext);